import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  TextField,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const TicketTagPickerModal = ({
  open,
  onClose,
  onSelect,
  kanban = 0,
  title = "Selecionar tag",
  confirmLabel = "Confirmar",
}) => {
  const [tags, setTags] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    const loadTags = async () => {
      try {
        const { data } = await api.get(`/tags/list?kanban=${kanban}`);
        setTags(Array.isArray(data) ? data : []);
      } catch (err) {
        toastError(err);
      }
    };

    setSearch("");
    setSelectedId(null);
    loadTags();
  }, [open, kanban]);

  const filteredTags = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return tags;
    return tags.filter((tag) =>
      String(tag.name || "")
        .toLowerCase()
        .includes(term)
    );
  }, [tags, search]);

  const handleConfirm = async () => {
    if (!selectedId) return;
    setLoading(true);
    try {
      const tag = tags.find((item) => item.id === selectedId);
      await onSelect(selectedId, tag);
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Pesquisar..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <List dense style={{ maxHeight: 320, overflowY: "auto", marginTop: 8 }}>
          {filteredTags.map((tag) => (
            <ListItem
              button
              key={tag.id}
              selected={selectedId === tag.id}
              onClick={() => setSelectedId(tag.id)}
            >
              <Chip
                size="small"
                label={tag.name}
                style={{
                  backgroundColor: tag.color || "#999",
                  color: "#fff",
                  marginRight: 8,
                }}
              />
              <ListItemText primary={tag.name} />
            </ListItem>
          ))}
          {filteredTags.length === 0 && (
            <ListItem>
              <ListItemText primary="Nenhuma tag encontrada" />
            </ListItem>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedId || loading}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketTagPickerModal;
